<div class="amadeus-direct-style business-content">
  <div class="contracts-table__container table-sortable__container" *ngIf="contractsState$ | async as contractsSt">
    <ng-container *ngIf="invoicesConfigState$ | async as invoicesConfig">
      <ng-container *ngIf="!contractsSt.isLoading; else spinner">
        <ng-container *ngIf="!contractsSt.loadingError; else loadingError">
          <table *ngIf="contractsSt.contracts.length > 0" class="contracts-table table-sortable">
            <thead>
              <tr>
                <td>
                  <a
                    class="sorting-link descending active"
                    data-sorting="created_at"
                    (click)="sort(contractsSt.sorting)"
                    [ngClass]="contractsSt.sorting === 'DESC' ? 'descending' : 'ascending'"
                    >{{ accountContractsTableDate }}</a
                  >
                </td>
                <td *ngIf="invoicesConfig.config.display_contract_type">
                  {{ accountContractsContractTypeLabel }}
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody class="table-sortable">
              <tr *ngFor="let contract of contractsSt.contracts">
                <td>{{ contract.fileDate | date: 'contracts' }}</td>
                <td
                  *ngIf="invoicesConfig.config.display_contract_type"
                  [innerHTML]="!contract['type'] ? '' : contractTypeTranslationMap[contract['type']]"
                >
                  {{ contract['type'] }}
                </td>
                <td>
                  <a href="{{ contract.url }}" target="_blank">{{ accountOrdersDetailsDownloadPdf }}</a>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="no-results"></p>
          <div *ngIf="contractsSt.contracts.length === 0">{{ accountContractsNoContractsLoaded }}</div>
          <div class="text-center"></div>
        </ng-container>
      </ng-container>

      <ng-template #loadingError>
        <loading-error [message]="contractsSt?.loadingError"></loading-error>
      </ng-template>

      <ng-template #spinner>
        <spinner fixed="true"></spinner>
      </ng-template>
    </ng-container>
  </div>
</div>
